import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Oferta.module.css';

const Oferta = () => {
  return (
    <div className={styles.ofertaPage}>
      <div className={styles.container}>
        <Link to="/" className={styles.backLink}>← На главную</Link>
        
        <h1 className={styles.title}>
          ПУБЛИЧНАЯ ОФЕРТА<br />
          о заключении договора оказания цифровых услуг
        </h1>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2 className={styles.heading}>1. Общие положения</h2>
            <p className={styles.paragraph}>
              1.1. Настоящий документ является официальным предложением (публичной офертой) самозанятого гражданина РФ — Калмыковой Анны Александровны, ИНН 745109437025, именуемой далее «Исполнитель», в адрес любого дееспособного физического или юридического лица, именуемого далее «Заказчик», заключить договор оказания цифровых услуг в соответствии со статьями 435 и 437 Гражданского кодекса Российской Федерации.
            </p>
            <p className={styles.paragraph}>
              1.2. Договор считается заключенным с момента акцепта настоящей оферты Заказчиком. Акцептом признается полная и безоговорочная оплата Заказчиком стоимости Услуги через электронные средства оплаты, указанные на сайте www.annavision.me.
            </p>
            <p className={styles.paragraph}>
              1.3. Совершая оплату, Заказчик подтверждает, что ознакомлен с условиями настоящей оферты, принимает их без исключений и ограничений и признаёт юридическую силу электронного акцепта договора.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>2. Термины и определения</h2>
            <p className={styles.paragraph}>
              <strong>Услуга</strong> — предоставление персональной онлайн консультации в виде индивидуально рассчитанного прогноза по системе 9 Дворцов на 2026 год на основе данных рождения Заказчика (дата, время, место рождения). Результат предоставляется в электронном виде (PDF-файл) путем отправки на указанный Заказчиком адрес электронной почты.
            </p>
            <p className={styles.paragraph}>
              <strong>Цифровой контент</strong> — индивидуально рассчитанная консультация в виде электронного документа (PDF-файл), содержащая персональный прогноз на 2026 год, рассчитанный по карте рождения Заказчика с учетом всех индивидуальных параметров.
            </p>
            <p className={styles.paragraph}>
              <strong>Сайт</strong> — интернет-ресурс Исполнителя, расположенный по адресу: www.annavision.me.
            </p>
            <p className={styles.paragraph}>
              <strong>Заказчик</strong> — лицо, оплатившее Услугу в порядке, установленном настоящей Офертой, и заполнившее анкету с данными рождения.
            </p>
            <p className={styles.paragraph}>
              <strong>Исполнитель</strong> — Калмыкова Анна Александровна, ИНН 745109437025.
            </p>
            <p className={styles.paragraph}>
              <strong>Акцепт</strong> — полная оплата Услуги через платёжную систему, интегрированную на Сайте.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>3. Предмет договора</h2>
            <p className={styles.paragraph}>
              3.1. Исполнитель обязуется предоставить Заказчику Услугу, а Заказчик обязуется оплатить её на условиях настоящей Оферты.
            </p>
            <p className={styles.paragraph}>
              3.2. Услуга оказывается в виде индивидуальной консультации — персонального расчета прогноза по системе 9 Дворцов на 2026 год на основе данных рождения Заказчика (дата, время, место рождения), предоставленных Заказчиком при заполнении анкеты после оплаты. Расчет производится вручную с учетом всех индивидуальных параметров и занимает до 21 (двадцати одного) календарного дня с момента заполнения Заказчиком анкеты с полными данными рождения.
            </p>
            <p className={styles.paragraph}>
              3.3. Результат Услуги предоставляется Заказчику в виде электронного документа (PDF-файл), отправляемого на адрес электронной почты, указанный Заказчиком при заполнении анкеты. Заказчик несет ответственность за корректность указанного адреса электронной почты.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>4. Порядок оказания Услуги</h2>
            <p className={styles.paragraph}>
              4.1. После оплаты Услуги Заказчик перенаправляется на страницу заполнения анкеты, где необходимо указать: адрес электронной почты, дату рождения, время рождения (если известно), место рождения (город и страна). Заказчик обязуется предоставить точные и достоверные данные.
            </p>
            <p className={styles.paragraph}>
              4.2. После заполнения анкеты Исполнитель приступает к индивидуальному расчету персонального прогноза на основе предоставленных данных. Срок оказания Услуги составляет до 21 (двадцати одного) календарного дня с момента заполнения Заказчиком анкеты с полными данными рождения.
            </p>
            <p className={styles.paragraph}>
              4.3. По истечении срока оказания Услуги Исполнитель направляет результат Заказчику на указанный адрес электронной почты в виде PDF-файла. Услуга считается оказанной в полном объеме с момента отправки результата на электронный адрес Заказчика.
            </p>
            <p className={styles.paragraph}>
              4.4. Информация, содержащаяся в консультации, носит ознакомительный характер, не является медицинской, психологической, юридической или иной профессиональной консультацией обязательного характера.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>5. Стоимость и порядок оплаты</h2>
            <p className={styles.paragraph}>
              5.1. Стоимость Услуги составляет 21 739 (двадцать одна тысяча семьсот тридцать девять) рублей.
            </p>
            <p className={styles.paragraph}>
              5.2. Оплата осуществляется безналичным способом через платёжные системы, указанные на сайте (в том числе через Stripe для международных карт или иные платёжные системы для карт РФ).
            </p>
            <p className={styles.paragraph}>
              5.3. Оплата означает согласие Заказчика с условиями настоящей Оферты и является акцептом оферты.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>6. Порядок возврата и ограничения</h2>
            <p className={styles.paragraph}>
              6.1. В соответствии с пунктом 11 Правил, утверждённых Постановлением Правительства РФ № 2463 от 31.12.2020, цифровой контент, предоставляемый по требованию потребителя и не подлежащий возврату после предоставления, не подлежит возврату после начала оказания Услуги.
            </p>
            <p className={styles.paragraph}>
              6.2. Исполнитель приступает к оказанию Услуги (индивидуальному расчету) после заполнения Заказчиком анкеты. С момента заполнения анкеты Услуга считается начатой, и возврат денежных средств не производится, за исключением случаев, указанных в пунктах 6.3-6.4.
            </p>
            <p className={styles.paragraph}>
              6.3. Возврат денежных средств возможен только в случае, если Исполнитель не предоставил результат Услуги в установленный срок (21 календарный день с момента заполнения анкеты) по причинам, не зависящим от Заказчика. В этом случае Заказчик вправе направить обращение на e-mail: keys@annavision.me с требованием о возврате.
            </p>
            <p className={styles.paragraph}>
              6.4. Возврат денежных средств также возможен при техническом сбое, приведшем к невозможности оплаты или двойной оплате. В этом случае Заказчик вправе направить обращение на e-mail: keys@annavision.me в течение 24 часов с момента возникновения проблемы.
            </p>
            <p className={styles.paragraph}>
              6.5. Возврат осуществляется по решению Исполнителя на тот же способ оплаты, которым была произведена оплата, в течение 10 рабочих дней после получения обоснованного обращения.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>7. Права и обязанности сторон</h2>
            <h3 className={styles.subheading}>Обязанности Исполнителя:</h3>
            <ul className={styles.list}>
              <li>Оказать Услугу надлежащим образом в установленные сроки (до 21 календарного дня с момента заполнения анкеты);</li>
              <li>Произвести индивидуальный расчет персонального прогноза на основе предоставленных Заказчиком данных;</li>
              <li>Отправить результат Услуги на указанный Заказчиком адрес электронной почты в виде PDF-файла;</li>
              <li>Уведомить Заказчика об условиях оказания Услуги до её оплаты.</li>
            </ul>
            <h3 className={styles.subheading}>Обязанности Заказчика:</h3>
            <ul className={styles.list}>
              <li>Ознакомиться с условиями Оферты до оплаты;</li>
              <li>После оплаты заполнить анкету, указав точные и достоверные данные рождения (дата, время, место рождения) и корректный адрес электронной почты;</li>
              <li>Самостоятельно обеспечить техническую возможность получения Услуги (устройство, интернет, доступ к электронной почте);</li>
              <li>Сохранить полученный результат Услуги (PDF-файл) на своём устройстве.</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>8. Конфиденциальность и персональные данные</h2>
            <p className={styles.paragraph}>
              8.1. Исполнитель обрабатывает персональные данные Заказчика (дата рождения, время рождения, место рождения, адрес электронной почты) исключительно в целях оказания Услуги и направления результата Услуги.
            </p>
            <p className={styles.paragraph}>
              8.2. Исполнитель обязуется не передавать персональные данные Заказчика третьим лицам, за исключением случаев, предусмотренных законодательством РФ.
            </p>
            <p className={styles.paragraph}>
              8.3. Заказчик дает согласие на обработку указанных персональных данных в целях оказания Услуги путем акцепта настоящей Оферты и заполнения анкеты.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>9. Форс-мажор</h2>
            <p className={styles.paragraph}>
              9.1. Стороны освобождаются от ответственности за неисполнение обязательств при наступлении обстоятельств непреодолимой силы, таких как: перебои в работе интернета, действия государственных органов, стихийные бедствия и др.
            </p>
            <p className={styles.paragraph}>
              9.2. Исполнитель не несет ответственности за невозможность оказания услуги вследствие сбоев на стороне платёжных или телекоммуникационных провайдеров.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>10. Разрешение споров</h2>
            <p className={styles.paragraph}>
              10.1. Споры разрешаются путем переговоров, а при недостижении соглашения — в судебном порядке в соответствии с законодательством РФ, с обязательным досудебным порядком (направление претензии по e-mail).
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>11. Срок действия оферты</h2>
            <p className={styles.paragraph}>
              11.1. Настоящая Оферта вступает в силу с момента её размещения на сайте и действует до момента её отзыва Исполнителем.
            </p>
            <p className={styles.paragraph}>
              11.2. Исполнитель вправе в любой момент изменить или отозвать Оферту, разместив соответствующее уведомление на сайте.
            </p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.heading}>12. Реквизиты Исполнителя</h2>
            <div className={styles.details}>
              <p className={styles.paragraph}>
                <strong>Ф.И.О.:</strong> Калмыкова Анна Александровна<br />
                <strong>ИНН:</strong> 745109437025<br />
                <strong>Правовой статус:</strong> самозанятая (налоговый режим — НПД)<br />
                <strong>E-mail:</strong> keys@annavision.me<br />
                <strong>Сайт:</strong> www.annavision.me
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Oferta;

